import { IDictionary } from "@oqdo/automationapps";

export interface IMergedDictionary<T> {
  [key: string]: { val1: T; val2: T };
}

export function mergeDictionaries<T>(
  dict1: IDictionary<T> | undefined,
  dict2: IDictionary<T> | undefined,
  defaultValue: T
): IMergedDictionary<T> {
  const merged: IMergedDictionary<T> = {};
  const keys1 = Object.keys(dict1 ?? {});
  const keys2 = Object.keys(dict2 ?? {});

  const allKeys = new Set([...keys1, ...keys2]);
  const filteredKeys = new Set([...allKeys].filter((key) => ((dict1?.[key] ?? 0 > 0) || dict2?.[key]) ?? 0 > 0));

  filteredKeys.forEach((key) => {
    merged[key] = {
      val1: dict1?.[key] ?? defaultValue,
      val2: dict2?.[key] ?? defaultValue,
    };
  });

  return merged;
}

export const getMergedProducts = (
  products: IDictionary<number> | undefined,
  stripeProducts: IDictionary<number> | undefined
) => Object.entries(mergeDictionaries(products, stripeProducts, 0)).sort((a, b) => a[0].localeCompare(b[0]));
